<template>
  <v-drawer 
    :active.sync="active" 
    :drawerData="drawerData" 
    :drawerType="drawerType" 
    :drawerValue.sync="currentVariant" 
    :addproduct.sync="addproduct"
    :drawerIndex="drawerIndex"
    @fatherMethod="childMethod"
    :loading="loading"
    :stock="stock"
    :quickAddCart="quickAddCart"
    :variant-new="variantNew"
    :product="product"
    :regular-price="regularPrice"
    :price="price"
    :variant-attrs="variantAttrs"
  >
    <div 
      class="quickPurchased quick-purchased" 
      style="display: none" 
      :class="[pcModelClass[quickAddCart.pc_style],mbModelClass[quickAddCart.mobile_style]]"
    >
      <div 
        class="container"
      >
        <div
          class="row align-items-center justify-content-between product-content "
          :class="{'showtime_quick':type==='showtime'}"
        >
          <div 
            class="quick_left align-items-center" 
            :class="{'col-md-3':!(quickAddCart.pc_style=='3')}"
          >
            <div
              class="quick_left_img product_media"
              v-if="
                (variantNew.feature_image && variantNew.feature_image.url) ||
                (product.gallery && product.gallery.length && product.gallery[0].url)
              "
            >
              <div :class="['square']" class="product_media_img">
                <v-lazy-img
                  class="img-fluid lazyload"
                  :data-url="
                    (variantNew.feature_image && variantNew.feature_image.url) ||
                    (product.gallery && product.gallery.length && product.gallery[0].url)
                  "
                  :src="
                    (variantNew.feature_image && variantNew.feature_image.thumbnail) ||
                    (product.gallery && product.gallery.length && product.gallery[0].thumbnail)
                  "
                ></v-lazy-img>
              </div>
            </div>
            <div class="quick_left_content">
              <h2
                class="page_text_font"
                :class="{'text-overflow-2':quickAddCart.pc_style == 3}"
                @click="$('html,body').animate({ scrollTop: '0px' }, 300)"
              >
                {{ product.post_title }}
              </h2>
              <v-selectprice
                v-if="!(quickAddCart.pc_style=='3')"
                :price="price"
                :font-size="showCurrencySelector ? 14 : 16"
                :regular-font-size="showCurrencySelector ? 12 : 15"
                type="reverse"
                :regular_price_num="Number(regularPrice) > Number(price) ? regularPrice : ''"
                :disable_select="true"
                :currency_style="currencyStyle"
                :country="type == 'showtime'?!showCurrencySelector?'':$store.state.pricetype:''"
                :appendToBody="false"
              ></v-selectprice>
              <div 
                class="variants_text" 
                v-else
              >
                {{currentVariant.map(el=>el.value).join(' / ')}}
              </div>
            </div>
          </div>
          <div 
            class="quick_right align-items-center" 
            :class="{'defalut_mb':type === 'default',
                    'col-md-9':!(quickAddCart.pc_style=='3')}"
          >
            <div 
              class="product_variants secondary_title"
              v-if="product.variants && 
                    product.variants.length>1 && 
                    !(quickAddCart.pc_style=='3') && 
                    !!variantAttrs"
            >
              <div
                class="product_variant"
                v-for="(item, index) in variantAttrs"
                :key="'quick' + item.name + index"
              >
                <label 
                  v-if="!(quickAddCart.pc_style=='2')" 
                  class="variant_label secondary_title" 
                  :for="'quick' + item.name + index" 
                  style="text-transform: capitalize"
                >
                  {{ item.name }}
                </label>
                <div class="variant_wrapper" >
                  <v-new-variant-select 
                    :current-variant.sync="currentVariant[index].value" 
                    :variant-item-list="item.value"
                    unfold-direction='top'
                  >
                  </v-new-variant-select>
                </div>
              </div>
              <div class="quantity">
                <input
                  type="number"
                  v-model="quantity"
                  :min="1"
                  :max="100000"
                  @change="change_quantity"
                />
              </div>
            </div>
            <div 
              class="commoditynum secondary_title" 
              v-if="!(quickAddCart.pc_style=='3')"
            >
              <div 
                v-if="!(quickAddCart.pc_style=='2')" 
                class="quantity-label secondary_title"
              >
                {{ $t("detail.quantity") }}
              </div>
              <my-el-input-number
                v-model="addproduct.quantity"
                :min="1"
                :max="100000"
                @keyup.enter.native="stock&&!loading && childMethod()"
                :step="1"
                step-strictly
              ></my-el-input-number>
            </div>
            <div 
              class="total_price" 
              v-if="(quickAddCart.pc_style=='3')"
            >
              <v-selectprice
                :price="price"
                :showCountryBefore="true"
                :show_regular_price_before="true"
                :font-size="showCurrencySelector ? 14 : 16"
                :regular-font-size="15"
                type="reverse"
                :regular_price_num=" Number(regularPrice) > Number(price) ? regularPrice : ''"
                :disable_select="true"
                :currency_style="currencyStyle"
                :country="$store.state.pricetype"
                :appendToBody="false"
              ></v-selectprice>
            </div>
          </div>
        </div>
        <div>
          <template v-if="stock">
            <div v-if="quickAddCart.button_type=='add_cart'">
              <el-button
                class="gocart sm_button main_button secondary_title"
                type="button"
                native-type="submit"
                :loading="loading"
                :disabled="!stock"
                @click="childMethod()"
                style="background: #000;
                      color: #fff;
                      margin: 5px;
                      display: inline-block;"
                :style="{ opacity: !stock ? '0.5' : '1' }"
              >
                <i class="iconfont icon-gouwuche" />
                {{ $t("detail.add_to_cart") }}
              </el-button>
            </div>
            <div v-else>
              <el-button
                class="buynow sm_button main_button secondary_title gocart"
                type="button"
                native-type="submit"
                :loading="loading"
                :disabled="!stock"
                @click="!loading && childMethod('buynow', true)"
                style="background: #000;
                      color: #fff;
                      margin: 5px;
                      display: inline-block; "
                :style="{ opacity: !stock ? '0.5' : '1' }"
              >
                {{ $t("detail.but_it_now") }}
              </el-button>
            </div>
          </template>
          <el-button
            v-else
            class="gocart soldout secondary_title"
            type="button"
            disabled
          >
            {{$t('detail.sold_out')}}
          </el-button>
        </div>
      </div>
      <!-- 快捷加购移动端 -->
      <div 
        class="container-mb"
      >
        <div 
          v-if="quickAddCart.mobile_style=='1'" 
          class="mb_content_1"
        >
          <div class="mb_content_1__top"
            v-if="!!variantAttrs"  
          >
            <div
              class="product_variant"
              v-for="(item, index) in variantAttrs"
              :key="'quick' + item.name + index"
              :style="{width:((1/variantAttrs.length)*100)+'%'}"
            >
              <v-new-variant-select 
                class="variant_select"
                :current-variant.sync="currentVariant[index].value" 
                :variant-item-list="item.value"
                unfold-direction='top'
                @visible-change="(bool)=>{active = bool;drawerData = item.value;drawerType = 'select';drawerIndex=index}"
              >
              </v-new-variant-select>
            </div>
          </div>
          <div class="mb_content_1__bottom">
            <my-el-input-number
                v-model="addproduct.quantity"
                :min="1"
                :max="100000"
                @keyup.enter.native="stock&&!loading && childMethod()"
                :step="1"
                step-strictly
            ></my-el-input-number>
            <div class="quickButton">
              <template v-if="stock">
                <div v-if="quickAddCart.button_type=='add_cart'">
                  <el-button
                    class="gocart sm_button main_button secondary_title"
                    type="button"
                    native-type="submit"
                    :loading="loading"
                    :disabled="!stock"
                    @click="childMethod()"
                    style="background: #000;
                          color: #fff;
                          margin: 5px;
                          display: inline-block;"
                    :style="{ opacity: !stock ? '0.5' : '1' }"
                  >
                    <i class="iconfont icon-gouwuche" />
                    {{ $t("detail.add_to_cart") }}
                  </el-button>
                </div>
                <div v-else>
                  <el-button
                    class="buynow sm_button main_button secondary_title gocart"
                    type="button"
                    native-type="submit"
                    :loading="loading"
                    :disabled="!stock"
                    @click="!loading && childMethod('buynow',true)"
                    style="background: #000;
                          color: #fff;
                          margin: 5px;
                          display: inline-block; "
                    :style="{ opacity: !stock ? '0.5' : '1' }"
                  >
                    {{ $t("detail.but_it_now") }}
                  </el-button>
                </div>
              </template>
              <el-button
                v-else
                class="gocart soldout secondary_title"
                type="button"
                disabled
              >
                {{$t('detail.sold_out')}}
              </el-button>
            </div>
          </div>
        </div>
        <div 
          class="mb_content_2" 
          v-else-if="quickAddCart.mobile_style=='2'"
        >
          <div class="mb_content_2__left" >
            <div
              class="quick_left_img"
              v-if="
                (variantNew.feature_image && variantNew.feature_image.url) ||
                (product.gallery && product.gallery.length && product.gallery[0].url)
              "
            >
              <v-lazy-img
                class="sm_img"
                :data-url="
                  (variantNew.feature_image && variantNew.feature_image.url) ||
                  (product.gallery && product.gallery.length && product.gallery[0].url)
                "
                :src="
                  (variantNew.feature_image && variantNew.feature_image.thumbnail) ||
                  (product.gallery && product.gallery.length && product.gallery[0].thumbnail) ||
                  defaultImage
                "
              ></v-lazy-img>
            </div>
            <div class="mb_content_2__center">
              <v-selectprice
                :price="price"
                :font-size="16"
                :regular-font-size="12"
                type="reverse"
                :regular_price_num="Number(regularPrice) > Number(price) ? regularPrice : ''"
                :disable_select="true"
                :currency_style="currencyStyle"
                :country="type == 'showtime'?!showCurrencySelector?'':$store.state.pricetype:''"
                :appendToBody="false"
              ></v-selectprice>
              <div class="variant_text">
                {{currentVariant.map(el=>el.value).join(' / ')}}
              </div>
            </div>
          </div>
         
          <div class="mb_content_2__right">
            <template v-if="stock">
              <div v-if="quickAddCart.button_type=='add_cart'">
                <el-button
                  class="gocart sm_button main_button secondary_title"
                  type="button"
                  native-type="submit"
                  :loading="loading"
                  :disabled="!stock"
                  @click="childMethod()"
                  style="background: #000;
                        color: #fff;
                        margin: 5px;
                        display: inline-block;"
                  :style="{ opacity: !stock ? '0.5' : '1' }"
                >
                  <i class="iconfont icon-gouwuche" />
                  {{ $t("detail.add_to_cart") }}
                </el-button>
              </div>
              <div v-else>
                <el-button
                  class="buynow sm_button main_button secondary_title gocart"
                  type="button"
                  native-type="submit"
                  :loading="loading"
                  :disabled="!stock"
                  @click="!loading && childMethod('buynow',true)"
                  style="background: #000;
                        color: #fff;
                        margin: 5px;
                        display: inline-block; "
                  :style="{ opacity: !stock ? '0.5' : '1' }"
                >
                  {{ $t("detail.but_it_now") }}
                </el-button>
              </div>
            </template>
            <el-button
              v-else
              class="gocart soldout secondary_title"
              type="button"
              disabled
            >
              {{$t('detail.sold_out')}}
            </el-button>
          </div>
        </div>
        <div 
          class="mb_content_3" 
          v-else 
        >
         <el-button
            v-if="stock"
            class="gocart sm_button main_button secondary_title"
            type="button"
            native-type="submit"
            :loading="loading"
            @click="()=>{active = true;drawerValue = currentVariant;drawerType = 'object'}"
            style="background: #000;
                  color: #fff;
                  margin: 5px;
                  display: inline-block;"
          >
            <template v-if="quickAddCart.button_type=='add_cart'">
              <i class="iconfont icon-gouwuche" />
              {{ $t("detail.add_to_cart") }}
            </template>
            <template v-else>
              {{ $t('detail.but_it_now')}}
            </template>
          </el-button>
          <el-button
              v-else
              class="gocart soldout secondary_title"
              type="button"
              disabled
            >
              {{$t('detail.sold_out')}}
            </el-button>
        </div>
      </div>
    </div>
  </v-drawer>
</template>

<script>
import ImgCard from '../../common/imgCard.vue';
import VDrawer from "./drawer.vue"
import VNewVariantSelect from './newVariantSelect.vue'
import myElInputNumber from "@/js/components/myElement/myElInputNumber.vue"
import { mapState } from 'vuex';
import throttle from "lodash/throttle"

export default {
  props:{
    quickAddCart:{
      type:Object,
      require:true,
    },
    type:{
      type:String,
      require:true,
    },
    variantNew:{
      type:Object,
      require:true,
    },
    product:{
      type:Object,
      require:true,
    },
    price:{
      type:String,
      require:true,
    },
    regularPrice:{},
    showCurrencySelector:{
      type:Boolean,
      require:true,
    },
    addproduct:{
      type:Object,
      require:true,
    },
    variantAttrs:{
      type:Array,
      require:false,
      default:()=>[]
    },
    currencyStyle:{
      type:String,
      require:true, 
    },
    currentVariant:{
      type:Array,
      require:false,
      default:()=>[]
    },
    stock:{
      type:Boolean,
      require:true,
    },
    showQuickAddCart:{},
    loading:{},
  },
  data() {
    return {
      // defaultImage,
      quantity: 1,
      quickHeight: null,
      active: false,
      drawerData:null,
      drawerType:'default',
      drawerIndex:0,
      pcModelClass:{1:'pc_model_1',2:'pc_model_2',3:'pc_model_3'},
      mbModelClass:{1:'mb_model_1',2:'mb_model_2',3:'mb_model_3'},
      tidioUpFlag:false,
    };
  },
  components:{
    VDrawer,
    ImgCard,
    VNewVariantSelect,
    myElInputNumber
  },
  methods: {
    change_quantity() {
      this.addproduct.quantity = this.quantity;
    },
    handleScroll() {
      // console.log(window.pageYOffset)
      this.quickHeight =
        this.$(".quickPurchased").innerHeight() > this.quickHeight
          ? this.$(".quickPurchased").innerHeight()
          : this.quickHeight;
      let tidioDOM = document.getElementById('tidio-chat-iframe')
      if (document.querySelector('.addToCartAllThemeBtnClass')?.getBoundingClientRect()?.bottom < 0) {
        this.$(".quickPurchased").slideDown(300);
        this.$(".commonfoot").css("paddingBottom", this.quickHeight + "px");
        if(tidioDOM && !this.tidioUpFlag){
          tidioDOM.style.bottom = this.isMobile?'110px':'180px'
          tidioDOM.style.right = '25px'
          this.tidioUpFlag = true
        }
      } else {
        this.$(".quickPurchased").slideUp(300);
        if(tidioDOM && this.tidioUpFlag){
          tidioDOM.style.bottom = '0px'
          this.tidioUpFlag = false
        }
      }
    },
    // imageFailure(e) {
    //   e.target.src = this.defaultImage;
    // },
    childMethod(data,onlySelf) {
      this.$emit("fatherMethod",data,onlySelf);
    },
  },
  mounted() {
    if (this.showQuickAddCart) {
      document.addEventListener("scroll", throttle(this.handleScroll,300), true);
    }
  },
  computed: {
    ...mapState({
       isMobile: ({ isMobile }) => isMobile,
    })
  },
  watch: {
    addproduct: {
      handler(newV, oldV) {
        this.quantity = newV.quantity;
        //this.add_cart_data.quantity = newV.quantity;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.show-Overlay {
  background-color: #000;
  opacity: 0.5;
  z-index: 1001;
  visibility: visible;
}
.drawerBox{
  display: flex;
  position: fixed;
  z-index: 2001;
  bottom: 0;
  width: 100%;
  background-color: #fff;
}
.soldout {
  background: #f6f6f6 !important;
  color: #717171 !important;
  border: none;
  border: 1px solid #717171 !important;
}
#app .quickPurchased {
  width: 100%;
  // height: 70px;
  padding: 15px 0;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 203;
  box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.08);
  .container-mb{
    display: none;
  }
  .container {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
    .gocart {
      white-space: nowrap;
      margin: 0;
      line-height: 2;
    }
    .row{
      width: 100%;
    }
    .quick_left {
      display: flex;
      padding: 0 12px;
      .quick_left_img {
        width: 68px;
        height: 68px;
        margin-right: 10px;
        flex-grow: 0;
        flex-shrink: 0;
        position: relative;
        img {
          max-width: 100%;
          border: none !important;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          -o-object-fit: contain !important;
          object-fit: contain !important;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          transition: all 0.3s ease-in-out;
        }
      }
      .quick_left_content {
        overflow: hidden;
        margin-left: 10px;
        h2 {
          font-size: 14px;
          color: #2f2f2f;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 700;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    
    .quick_right {
      display: flex;
      justify-content: flex-end;

      .commoditynum {
        font-size: 15px;
        margin-right: 24px;
        .quantity-label {
          color: #4d4d4d;
          margin-bottom: 6px;
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
        }
        &::v-deep {
          .el-input-number {
            width: 130px !important;
            &__decrease,
            &__increase {
              height: 30px;
              border-radius: 0;
              width: 29px;
              background: unset;
              i {
                vertical-align: text-top;
                font-weight: 600 !important;
              }
              &:hover {
                color: #606266;
              }
            }
            .el-input {
              line-height: 1 !important;
              &__inner {
                line-height: normal;
                height: 32px;
                border-radius: 0px !important;
                font-size: 18px;
                background-color: #ffffff !important ;
                padding: 5px 25px !important;
                border: 1px solid #dcdfe6 !important;
              }
            }
          }
        }
        
      }
      .product_variants {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        overflow: hidden;
        margin-right: 16px;
        .product_variant {
          width: 33.33333%;
          margin-left: 16px;
          .variant_label {
            display: block;
            max-width: 100%;
            color: #4d4d4d;
            margin-bottom: 6px;
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .quantity {
          display: none;
          input {
            background-color: #fff;
            width: 70px;
            height: 100%;
            padding: 1px 10px;
            border: none;
          }
        }
      }
    }
  }
}

#app .product_variant{
  &::v-deep .variant_wrapper{
    .variant_select{
      margin: 0 !important;
      .popper{
        &__arrow{
          display: none !important;
        }
      }
      .selected{
        color: #606266 !important;
      }
    }
    .el-input{
      &__inner{
        height: 32px !important;
        border-radius: 0px !important;
        margin: 0px !important;
        background-color: #ffffff !important;
      }
      &__suffix{
        transform: rotate(180deg) !important;
        .el-select__caret{
          line-height: 32px !important;
        }
      }
    }
    .el-select{
      width: 100% !important;
    }
  }
} 

.gocart.soldout{
  border: 0 !important;
  background-color: #eeeeee !important;
  color: #999999 !important;
}

#app .pc_model_1{
  .container{
    .row{
      margin: 0 !important;
      align-items: flex-end !important;
      .quick_left,.quick_right{
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
  .el-input-number{
    &::v-deep{
      .el-input {
        &__inner {
          margin: 0 !important;
          background-color: #ffffff !important;
        }
      }
    }
  }
  .buynow,.gocart{
    border-radius: 0px !important;
    margin: 0 !important  
  }
}

#app .pc_model_2{
  .container{
    align-items: center !important;
    .product-content{
      margin: 0 !important;
      width: 88% !important;
      .quick_left,.quick_right{
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
  .product_variant{
    &::v-deep .new_variant_select{
      &__button{
        button{
          height: 44px !important;
        }
        .icon-arrow-up{
          top: 0px !important;
          transform-origin: 50% 50% !important;
        }
      }
    }
  }
  .el-input-number{
    &::v-deep{
      .el-input-number__decrease,.el-input-number__increase {
        height: 42px !important;
        i {
          vertical-align: text-bottom !important;
        }
      }
      .el-input {
        &__inner {
          height: 44px !important;
          margin: 0 !important;
          background-color: #ffffff !important;
        }
      }
    }
  }
  .gocart{
    height: 44px !important;
    line-height: 1 !important;
  }
  .buynow,.gocart{
    border-radius: 0px !important;
  }
}

#app .pc_model_3{
  // .container{
  //   align-items: center !important;
  //   .row{
  //     padding-right: 20px !important;
  //   }
  // }
   .container{
    align-items: center !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    .row{
      margin-right: -30px !important;
      margin-left: -30px !important;
      padding: 0 30px !important;
      .quick_left{
        flex: 1;
        max-width: 80%;
        .quick_left_content{
          display: grid;
        }
      }
      .quick_right{
        flex: none;
      }
    }
  }
  .variants_text{
    display: flex !important;
    line-height: 20px !important;
    margin-top: 4px !important;
    .variant_text:last-child{
      span{
        display: none !important;
      }
    }
  }
  .total_price{
    &::v-deep{
      .product_price_price{
        .money{
          font-size: 28px !important;
          font-weight: bold !important; 
        }
      }
    }
  }
  .gocart{
    height: 44px !important;
    line-height: 1 !important;
    border-radius: 0 !important;
  }
  .buynow,.gocart{
    border-radius: 0px !important;
  }
}

@media screen and  (max-width: 1000px){
  .quickPurchased {
    .container {
      .quick_left {
        .quick_left_img {
          display: none;
        }
      }
    }
  }
}
// @media screen and (max-width: 992px) {
//   .quickPurchased {
//     .container {
//       .quick_left {
//         max-width: 10%;
//         flex: 0 0 10%;
//         .quick_left_content {
//           display: none;
//         }
//       }
//       .gocart {
//         width: 100% !important;
//       }
//       .quick_right {
//         flex: 0 0 90%;
//         max-width: 90%;
//       }
//     }
//   }
// }

@media screen and (max-width: 768px) {
  #app .mb_model_1{
    padding: 0 !important;
    .mb_content_1{
      &__top{
        display: flex;
        flex-direction: row;
        .product_variant{
          &::v-deep .new_variant_select{
            width: 100% !important;
            &__option{
              display: none !important;
            }
            &__button{
              button{
                height: 44px !important;
                border-radius: 0px !important;
                border-left: 0px !important;
                border-bottom: 0px !important;
                margin: 0 !important;
                background-color: #ffffff !important;
              }
              .icon-arrow-up{
                top: 0px !important;
                transform-origin: 50% 50% !important;
              }
            }
          }
        }
        .product_variant:last-child{
          &::v-deep .new_variant_select{
            &__button{
              button{
                border-right: 0px !important;
              }
            }
          }
        }
      }
      &__bottom{
        display: flex;
        align-items: center;
        .el-input-number{
          width: 33.33%;
          &::v-deep{
            .el-input-number__decrease,.el-input-number__increase {
              height: 44px !important;
              border-radius: 0px !important;
              border-bottom: 0px !important;
              background-color: #fff !important;
              i {
                vertical-align: text-bottom !important;
              }
            }
            .el-input-number{
              &__decrease{
                border-left: 0px !important;
              }
              &__increase{
                border-right: 0px !important;
              }
            }
            .el-input {
              &__inner {
                height: 44px !important;
                border-radius: 0px !important;
                border-left: 0px;
                border-right: 0px;
                border-bottom: 0px;
                margin: 0 !important;
                background-color: #ffffff !important;
              }
              &__inner:not(.is-disabled){
                border-color: #DCDFE6 !important;
              }
            }
          }
        }
        .quickButton{
          width: calc(66.67% + 3px);
          .gocart{
            margin: 0 !important;
            width: 100%;
            border-radius: 0;
            height: 44px !important;
            line-height: 1 !important;
          }
          .buynow,.gocart{
            border-radius: 0px !important;
          }
        }
      }
    }
  }

  #app .mb_model_2{
    padding: 11px 24px !important;
    .mb_content_2{
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      &__left{
        display: flex;
        flex-direction: row;
        align-items: center;
        .quick_left_img{
          max-width: 42px;
          margin-right: 6px;
          img{
            width: 100%;
          }
        } 
      }
      &__center{
        .selectpricewrap,.variant_text{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .variant_text{
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
        }
      }
      &__right{
        margin-left: 6px;
        .gocart{
          margin: 0 !important;
          width: 100%;
          border-radius: 0;
          height: 42px !important;
          line-height: 1 !important;
        }
        .buynow,.gocart{
          border-radius: 0px !important;
        }
      }
    }
  }

  #app .mb_model_3{
    padding: 0;
    .mb_content_3{
      .gocart{
        height: 44px !important;
        margin: 0 !important;
        width: 100%;
        border-radius: 0;
      }
      .buynow,.gocart{
        border-radius: 0px !important;
      }
    }
  }

  div.quickPurchased {
    padding: 0;
    z-index:102;
    .container-mb{
      display: block !important;
    }
    div.container {
      display: none !important;
      padding: 0 !important;
      .quick_left {
        display: none;
      }
      .quick_right {
        flex: 0 0 100%;
        max-width: 100%;
        display: block;
        .gocart {
          border-radius: 3px;
          display: block !important;
          height: 50px;
          width: 100%;
          margin: 0 !important;
        }
        .product_variants {
          margin-right: 0;
          .product_variant {
            width: auto;
            flex: 1;
            margin-left: 0;
            .variant_label {
              display: none;
            }
            .variant_wrapper {
              select {
                border: none;
                border-right: 1px solid #e6e6e6;
              }
            }
          }
        }
        .commoditynum {
          display: none;
        }
        .quantity {
          display: block !important;
        }
      }
      .defalut_mb {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>